export default __webpack_public_path__ + "static/media/exort_icon.6077c06b.png";